/* eslint-disable  */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import Loader from "../../Components/Loader";
import { dataActionCreators } from "../../services/Actions";
import RenderAdminPage from "../RenderAdminPage";
import Chart from "../Components/Chart";
  
    function ChartPage() {
      const history = useHistory();
    const dispatch = useDispatch();
    const { GetLoansForStatistics } = bindActionCreators(dataActionCreators, dispatch);
    const [formData, setFormData] = useState({
        status: "",
        year: ""
    })
    const data = useSelector((state) => state?.data);
    const {isLoading,  loansStatistics} = data

    useEffect(() => {
        GetLoansForStatistics("paid")
    }, [])

    useEffect(() => {
        GetLoansForStatistics(formData.status)
    }, [formData.status])
  
    return (
      <div>
        <RenderAdminPage title="Charts">
          {isLoading && <Loader />}

          <div className="mb-6">
            <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Filter by Status</label>
            <select
              className="px-4 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-slate-800 dark:text-slate-200 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
              onChange={(e) => setFormData({...formData, status: e.target.value})}
            >
              <option value={"all"}>All</option>
              <option value={"paid"}>Paid</option>
              <option value={"submitted"}>Submitted</option>
              <option value={"booked"}>Booked</option>
              <option value={"initiated"}>Initiated</option>
              <option value={"authorized"}>Authorized</option>
              <option value={"rejected"}>Rejected</option>
            </select>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-slate-200 dark:border-gray-700 p-4 overflow-x-auto">
            <Chart loansStatistics={loansStatistics} width={1300} height={400} />
          </div>
        </RenderAdminPage>
      </div>
    );
    }
    
    export default ChartPage;
    